import React from 'react';
import { CalendarCell } from '@/components/organisms/EventCalendar/types';
import CalendarEventItem from '@/components/atoms/CalendarEventItem/CalendarEventItem';
import './CalendarDayCell.scss';

interface CalendarDayCellProps {
  cell: CalendarCell;
  onSelectEvent: (eventId: number) => void;
  formatTime: (value: string) => string;
}

const CalendarDayCell: React.FC<CalendarDayCellProps> = ({ cell, onSelectEvent, formatTime }) => {
  return (
    <div
      className={`events-calendar-page__cell ${cell.isCurrentMonth ? '' : 'is-outside'}`}
    >
      <div className="events-calendar-page__cell-date">
        {cell.date.getDate()}
      </div>
      <div className="events-calendar-page__cell-events">
        {cell.occurrences.map(occurrence => (
          <CalendarEventItem
            key={`${occurrence.event.id}-${occurrence.start_date}`}
            occurrence={occurrence}
            onSelect={onSelectEvent}
            formatTime={formatTime}
          />
        ))}
      </div>
    </div>
  );
};

export default CalendarDayCell;
